import React, { useEffect, useState } from 'react';

import { FormProvider, useForm } from 'react-hook-form';
import { observer } from 'mobx-react';
import { Box, Typography } from '@mui/material';
import { LbStepper } from '@infoods/lifebase-ui';

import classes from './Registration.module.scss';
import { registrationStepperStore } from '../../stores/registrationStepperStore';
import { TestStep } from './containers/TestStep/TestStep';
import { ActiveCalendarStep } from './containers/ActiveCalendarStep/ActiveCalendarStep';
import { InitialOrderStep } from './containers/InitialOrderStep/InitialOrderStep';
import { UserProfileStep } from './containers/UserProfileStep/UserProfileStep';
import { angularizeWithProviders } from '../../../shared/providers';
import { medicalTestsStore } from '../../stores/medicalTestsStore';

const formFieldsName = {
  userProfile: 'userProfile',
  testStep: 'testStep',
  activeCalendar: 'activeCalendar',
  initialOrder: 'initialOrder',
};

const stepsOptions = [
  {
    step: <UserProfileStep fieldName={formFieldsName.userProfile} />,
    label: 'User Profile',
  },
  { step: <TestStep fieldName={formFieldsName.testStep} />, label: 'Lab Tests' },
  {
    step: <ActiveCalendarStep fieldName={formFieldsName.activeCalendar} />,
    label: 'Select Supplements',
  },
  {
    step: <InitialOrderStep fieldName={formFieldsName.initialOrder} />,
    label: 'Set Beginning Inventory',
  },
];

const NgzRegistration = observer(() => {
  const [steps, setSteps] = useState(stepsOptions);
  const { activeStep, goToStep, setDefaultValues } = registrationStepperStore;
  const { isTestsDisabled, getTests } = medicalTestsStore;

  useEffect(() => {
    getTests();

    return setDefaultValues;
  }, []);

  useEffect(() => {
    if (isTestsDisabled) {
      deleteStep('Lab Tests');
    }
  }, [isTestsDisabled]);

  const deleteStep = (label) => {
    const newSteps = steps.filter((step) => step.label !== label);
    setSteps(newSteps);
  };

  const methods = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    defaultValues: {
      [formFieldsName.userProfile]: {},
      [formFieldsName.testStep]: [],
      [formFieldsName.activeCalendar]: {},
      [formFieldsName.initialOrder]: {},
    },
  });

  return (
    <FormProvider {...methods}>
      <Box className={classes.box}>
        <Typography className={classes.typography}>Add a new member</Typography>
        <LbStepper activeStep={activeStep} stepsArr={steps} goToStep={goToStep} />
      </Box>
    </FormProvider>
  );
});

angularizeWithProviders(NgzRegistration, 'ngzRegistration', {});

export default NgzRegistration;
